export function getValueByDotNotation(obj, path) {
    const parts = path.split('.');
    for (let i = 0; i < parts.length; i++) {
        obj = obj[parts[i]];
    }
    return obj;
}

export function setValueByDotNotation(obj, path, val) {
    if (
        !path ||
        !path.length ||
        Object.prototype.toString.call(path) !== '[object String]'
    ) {
        throw 'Invalid path to setValueByDotNotation';
    }

    if (obj !== Object(obj)) {
        //if it's not an object, make it one
        obj = {};
    }
    let keys = path.split('.');
    while (keys.length > 1) {
        const key = keys.shift();
        if (obj !== Object(obj)) {
            //if it's not an object, make it one
            obj = {};
        }
        if (!(key in obj)) {
            //if obj doesn't contain the key, add it and set it to an empty object
            obj[key] = {};
        }
        obj = obj[key];
    }
    return (obj[keys[0]] = val);
}

export function uuid(prefix) {
    var unique = 0;
    var uuid = function (prefix) {
        var time = Date.now();
        var random = Math.floor(Math.random() * 1000000000);
        unique++;
        return prefix + '_' + random + unique + String(time);
    };
    return uuid;
}

export function makeId(length = 16) {
    var result = '';
    var characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
}

export function roundWithDecimal(value, decimal) {
    return parseFloat(value.toFixed(decimal));
}

export function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function isFunction(variable) {
    const getType = {};
    return variable && getType.toString.call(variable) === '[object Function]';
}

export function isMobile() {
    return navigator.userAgent.toLowerCase().search('android') > -1;
}

export function copyTextToClipboard(text) {
    return new Promise((resolutionFunc, rejectionFunc) => {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
        }

        navigator.clipboard.writeText(text).then(
            function () {
                resolutionFunc();
            },
            function (err) {
                fallbackCopyTextToClipboard(text);
            }
        );

        function fallbackCopyTextToClipboard(text) {
            var textArea = document.createElement('textarea');

            textArea.value = text;

            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.position = 'fixed';

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                if (document.execCommand('copy')) {
                    resolutionFunc();
                } else {
                    rejectionFunc();
                }
            } catch (err) {
                rejectionFunc();
            } finally {
                document.body.removeChild(textArea);
            }
        }
    });
}
